import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {Subscription} from 'rxjs';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {PreviewTableComponent} from '../preview-table/preview-table.component';
import {MainPageComponent} from '../../../../../main/components/main/main-page.component';
import {IDataSourcePreview, OracleBodyReq} from '../../interfaces/i-data-source-preview';
import {ConfigConnectionForm, ConfigConnectionFormConnectiopnTypes} from '../../../../models/config-connection-form.model';
import {ConnectionForm} from '../../../../models/connection-form.model';
import {SubmitType} from '../../../../models/submit.type';
import {Connection} from '../../../../../main/modules/management/models/Connection.model';
import {ConnectionTables} from '../../../../models/connection-tables.model';
import {OracleConnection} from '../../../../../data-source/models/oracle-connection.model';
import {SqlServerConnection} from '../../../../../data-source/models/sql-server-connection.model';
import {ReplaceDataSourceConfirmUpdateComponent} from '../../../../../data-source/components/dialogs/replace-data-source-confirm-update/replace-data-source-confirm-update.component';
import {take} from 'rxjs/operators';
import {DataSourceFacade} from '../../../../../data-source/facade/data-source.facade';
import {DataSource} from "../../../../../data-source/models/data-source.modol";
import {DataSourceWarningMessageDialogComponent} from "../../../../../data-source/components/dialogs/data-source-warning-message-dialog/data-source-warning-message-dialog.component";
import {ConnectionType} from "../../../../../main/modules/management/models/connection.type";

@Component({
    selector: 'tart-management-data-base',
    templateUrl: './management-data-base.component.html',
    styleUrls: ['./management-data-base.component.scss'],
})
export class ManagementDataBaseComponent implements OnInit, OnDestroy {
    workspaceId: string;
    dataSourceId: string;
    currentDatasourceName: string;
    type: ConfigConnectionFormConnectiopnTypes;
    configuration: Partial<ConfigConnectionForm>;
    validForm: boolean;
    formValues: Partial<ConnectionForm>;
    formValueChangesData: Partial<ConnectionForm>;
    connections: Partial<Connection>[];
    connection: Partial<OracleConnection | SqlServerConnection>;
    connectionTables: Partial<ConnectionTables>;
    submitState: SubmitType;
    observables = [];
    subscriptions: Subscription[] = [];
    loading = false;
    dataSource: DataSource;
    selectedConnectionType;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private dialogRef: NbDialogRef<MainPageComponent>,
        private dialogService: NbDialogService,
        private dataSourceFacade: DataSourceFacade,
        @Inject('DataSourcePreview') private dataSourcePreviewFacade: IDataSourcePreview,
    ) {
    }

    ngOnInit() {
        this.init();
        this.setSubscribers();
        if(this.type === 'ReplaceSqlServer'){
            this.dataSourceFacade.checkDeleteDataSource(this.workspaceId,[this.dataSourceId]);
        }
    }

    init(){
      this.loadDataConnection();
      this.configurationForm();
    }

    loadDataConnection(): void {
        if (this.type === 'EditSqlServer') {
            this.loading = true;
            this.dataSourcePreviewFacade.loadSqlServerConnection(this.workspaceId, this.dataSourceId);
        } else if (this.type === 'EditOracle') {
            this.loading = true;
            this.dataSourcePreviewFacade.loadOracleConnection(this.workspaceId, this.dataSourceId);
        }
    }

    configurationForm(): void {
        this.configuration = {
            formType: this.type,
            hasName: true,
            name: 'نام منبع داده',
            hasConnectionKind: true,
            hasConnectionType: true,
            hasConnectionList: false,
            hasSelectTable: false,
            hasServer: true,
            hasServiceName: true,
            serviceName: 'نام پایگاه داده',
            hasWindowsAuthentication: true,
            hasUserAuthentication: true,
            hasCommandTimeout: true,
            hasStatement: true,
            titleStatement: 'پرس و جو (Query Statement)',
        };
        if(this.type === 'EditSqlServer' || this.type === 'CreateSqlServer' || this.type === 'ReplaceSqlServer') {
            this.dataSourcePreviewFacade.loadUserDataBaseConnections(this.workspaceId);
        }
    }

    setSubscribers(): void {
        this.subscriptions.push(this.dataSourcePreviewFacade.getSubmitState$().subscribe(
            (submitState) => {
                this.submitState = submitState;
                if (submitState === 'submitted') {
                    if (this.type === 'CreateOracle' || this.type === 'CreateSqlServer') {
                        const closeOnBackdropClick = false;
                        this.dialogService.open(PreviewTableComponent, {
                            context: {workspaceId: this.workspaceId, type: 'CreateDataSource'},
                            closeOnBackdropClick,
                        });
                        this.dataSourcePreviewFacade.setSubmitState('notSubmitted');
                        this.dialogRef.close(false);

                    }  if (this.type === 'ReplaceSqlServer') {

                        this.dialogService.open(PreviewTableComponent,
                            { context: 
                                {
                                    type: 'ReplacementExcelWithSql',
                                    oldDataSourceName: this.formValues?.name
                                },
                                closeOnBackdropClick: true,
                            })
                            .onClose
                            .pipe(take(1))
                            .subscribe(
                                (res: boolean) => {
                                    if(!res) return
                                    this.updateDataSourceAfterReplacement()

                                }
                            )

                        this.dataSourcePreviewFacade.setSubmitState('notSubmitted');
                        this.dialogRef.close(this.formValues.name);

                    } else if (this.type === 'EditOracle' || this.type === 'EditSqlServer') {
                        this.dataSourcePreviewFacade.setSubmitState('notSubmitted');
                        this.dialogRef.close(this.formValues.name);
                    }
                }
            },
        ));
        if(this.type === 'EditSqlServer' || this.type === 'CreateSqlServer' || this.type === 'ReplaceSqlServer') {
            
            this.subscriptions.push(this.dataSourcePreviewFacade.getConnections$().subscribe(
                (connections) => this.connections = connections));
            this.subscriptions.push(this.dataSourcePreviewFacade.getConnectionTables$().subscribe(
                (connectionTables) => {
                    this.connectionTables = connectionTables;
                }));
        }
        if (this.type === 'EditSqlServer') {
            this.subscriptions.push(this.dataSourcePreviewFacade.getSqlServerConnection$().subscribe(sqlServerConnection => {
                if (sqlServerConnection !== null) {
                    this.loading = false;
                    this.connection = sqlServerConnection;
                    if(sqlServerConnection.dbConnectionId != null) {
                        this.dataSourcePreviewFacade
                            .loadDataBaseConnectionTables(this.workspaceId,sqlServerConnection.dbConnectionId);
                    }
                }
            }));
        } else if (this.type === 'EditOracle') {
            this.subscriptions.push(this.dataSourcePreviewFacade.getOracleConnection$().subscribe(oracleConnection => {
                if (oracleConnection !== null) {
                    this.loading = false;
                    this.connection = oracleConnection;
                }
            }));
        }
    }

    submit(): void {
        if (this.type === 'CreateSqlServer') {
            this.createSqlServer();
        } else if (this.type === 'CreateOracle') {
            this.createOracle();
        } else if (this.type === 'EditSqlServer') {
          const _formValues: any = this.formValueChangesData;
          const _connection: any = this.connection;
          if(this.selectedConnectionType && this.selectedConnectionType!==this.connection?.connectionType){
            this.convertConnection();
          }else{
            if(this.dataSource?.isIncremental && _formValues?.selectedConnectionTable && _formValues?.selectedConnectionTable !== _connection?.tableName){
              const dialogRef = this.dialogService.open(DataSourceWarningMessageDialogComponent,
                {
                  context: {
                    warnings: [
                      'توجه! تنظیمات به‌روزرسانی تدریجی به به‌روزرسانی کامل تبدیل می‌شود.',
                      'توجه! هرگونه مغایرت در نام و نوع ستون‌ها منجر به حذف ستون می‌شود.',
                      'توجه! همه داشبوردهای منبع‌ داده فعلی طبق منبع‌ داده جدید به‌روز می‌شوند.',
                    ],
                    title:'هشدار',
                    message: `آﯾﺎ با جایگزینی منبع داده “${_connection?.tableName}” با منبع داده جدید “${_formValues?.selectedConnectionTable}” موافق هستید؟`,
                    type: 'simple',
                  },
                });
              dialogRef.onClose.subscribe(res=>{
                if(res){
                  this.updateSqlServer();
                }
              });
            }else{
              this.updateSqlServer();
            }
          }
        } else if (this.type === 'EditOracle') {
            this.updateOracle();
        } else if (this.type === 'ReplaceSqlServer') {
            this.replaceSqlServer();
        }
    }

    createSqlServer(): void {
        const sqlFromValues = this.formValues;
        if (sqlFromValues.connectionType === 'Queryable') {
            this.dataSourcePreviewFacade.createSqlServerConnection(this.workspaceId, sqlFromValues.name,
                sqlFromValues.serverAddress, sqlFromValues.portNumber, sqlFromValues.dbName, sqlFromValues.windowsAuth,
                sqlFromValues.username, sqlFromValues.password, sqlFromValues.commandTimeout,
                sqlFromValues.connectionStatement);
        } else if (sqlFromValues.connectionType === 'Selectable') {
            this.dataSourcePreviewFacade
                .createSqlServerDataBaseConnection(
                    this.connectionTables.tables[sqlFromValues.selectedConnectionTable],
                    this.connectionTables.dbConnectionId,
                    this.workspaceId, sqlFromValues.name,
                    sqlFromValues.hasRowLimited,
                    sqlFromValues.numberOfRowLimited,
                    sqlFromValues.hasTopN,
                    sqlFromValues.numberOfTopN,
                    );
        }
    }

    updateSqlServer(): void {
        const sqlFromValues = this.formValues;
        if (sqlFromValues.connectionType === 'Queryable') {
            this.dataSourcePreviewFacade.updateSqlServerConnection(this.workspaceId, this.dataSourceId,
                this.connection.connectionId, sqlFromValues.name, sqlFromValues.serverAddress,
                sqlFromValues.portNumber, sqlFromValues.dbName, sqlFromValues.windowsAuth,
                sqlFromValues.username, sqlFromValues.password,sqlFromValues.numberOfRowLimited,sqlFromValues.hasRowLimited, sqlFromValues.commandTimeout,
                sqlFromValues.connectionStatement);
        } else if (sqlFromValues.connectionType === 'Selectable') {
            this.dataSourcePreviewFacade
                .updateSqlServerDataBaseConnection(
                    this.workspaceId,
                    this.dataSourceId,
                    this.connection.connectionId,
                    this.connectionTables.dbConnectionId,
                    sqlFromValues.name,
                    this.connectionTables.tables[sqlFromValues.selectedConnectionTable],
                    sqlFromValues.hasRowLimited,
                    sqlFromValues.numberOfRowLimited,
                    sqlFromValues.hasTopN,
                    sqlFromValues.numberOfTopN);
        }
    }

    convertConnection(): void {
      const sqlFromValues = this.formValues;
      const _connection: any = this.connection
      const connectionName: string = this.connections.find(item=>item.id === _connection?.dbConnectionId)?.name
      if (this.selectedConnectionType === 'Queryable') {
        this.dataSourcePreviewFacade.convertAvailableDBConnectionToNewConnection(
          this.workspaceId,
          this.dataSourceId,
          this.connection.connectionId,
          {
            dataSourceName: sqlFromValues.name,
            serverAddress: sqlFromValues.serverAddress,
            windowsAuth: sqlFromValues.windowsAuth,
            dbName: sqlFromValues.dbName,
            password: sqlFromValues.password,
            commandTimeout: sqlFromValues.commandTimeout,
            connectionName,
            portNumber: sqlFromValues.portNumber,
            sqlStatement: sqlFromValues.connectionStatement,
            username: sqlFromValues.username,
          },
        );
      } else if (this.selectedConnectionType === 'Selectable') {
        this.dataSourcePreviewFacade.convertNewConnectionToAvailableDBConnection(
            this.workspaceId,
            this.dataSourceId,
            this.connection.connectionId,
          {
              connectionType: 'Selectable',
              numberOfRowLimited: sqlFromValues.numberOfRowLimited,
              numberOfTopN: sqlFromValues.numberOfTopN,
              hasRowLimited:sqlFromValues.hasRowLimited,
              hasTopN:sqlFromValues.hasTopN,
              dataSourceName: sqlFromValues.name,
              dbConnectionId:this.formValueChangesData.selectedConnection,
              tableId: this.connectionTables.tables[sqlFromValues.selectedConnectionTable],
              tableName: sqlFromValues.selectedConnectionTable,
              windowsAuth:_connection.windowsAuth,
              serverAddress: _connection.serverAddress,
              dbName: _connection.dbName,
              password: _connection.password,
              commandTimeout: _connection.commandTimeout,
              connectionName,
              portNumber: _connection.portNumber,
              sqlStatement: _connection.connectionStatement,
              username: _connection.username,
          });
      }
    }

    createOracle(): void {
        const oracleFormValue = this.formValues;
        const oracleBodyReq: Partial<OracleBodyReq> = {
            commandTimeout: oracleFormValue.commandTimeout,
            dataSourceId: this.dataSourceId,
            name: oracleFormValue.name,
            oracleConnectionType: oracleFormValue.oracleConnectionType,
            oracleAuthenticationType: oracleFormValue.windowsAuth ? 'OperatingSystemAuthentication' : 'OracleAuthentication',
            password: oracleFormValue.password,
            portNumber: oracleFormValue.portNumber,
            serverAddress: oracleFormValue.serverAddress,
            serviceIdentity: oracleFormValue.serviceIdentity,
            sqlStatement: oracleFormValue.connectionStatement,
            username: oracleFormValue.username,
            workspaceId: this.workspaceId,
        };

        this.dataSourcePreviewFacade.createOracleConnection(oracleBodyReq);
    }

    updateOracle(): void {
        const oracleFormValue = this.formValues;
        const oracleBodyReq: Partial<OracleBodyReq> = {
            commandTimeout: oracleFormValue.commandTimeout,
            dataSourceId: this.dataSourceId,
            name: oracleFormValue.name,
            oracleConnectionType: oracleFormValue.oracleConnectionType,
            oracleAuthenticationType: oracleFormValue.windowsAuth ? 'OperatingSystemAuthentication' : 'OracleAuthentication',
            password: oracleFormValue.password,
            portNumber: oracleFormValue.portNumber,
            serverAddress: oracleFormValue.serverAddress,
            serviceIdentity: oracleFormValue.serviceIdentity,
            sqlStatement: oracleFormValue.connectionStatement,
            username: oracleFormValue.username,
            workspaceId: this.workspaceId,
        };

        this.dataSourcePreviewFacade.updateOracleConnection(oracleBodyReq);
    }

    replaceSqlServer(): void {
        const sqlFromValues = this.formValues;
        if (sqlFromValues.connectionType === 'Queryable') {
            this.dataSourcePreviewFacade.replaceExcellWithSqlServerConnection(
                this.currentDatasourceName,
                this.dataSourceId,
                this.workspaceId,
                sqlFromValues.name, sqlFromValues.serverAddress,
                sqlFromValues.portNumber, sqlFromValues.dbName,
                sqlFromValues.windowsAuth, sqlFromValues.username,
                sqlFromValues.password, sqlFromValues.commandTimeout,
                sqlFromValues.connectionStatement);
        } else if (sqlFromValues.connectionType === 'Selectable') {
            this.dataSourcePreviewFacade
                .replaceExcellWithSqlServerDataBaseConnection(
                    this.currentDatasourceName,
                    this.dataSourceId,
                    this.connectionTables.tables[sqlFromValues.selectedConnectionTable],
                    this.connectionTables.dbConnectionId,
                    this.workspaceId,
                    sqlFromValues.name,
                    sqlFromValues.hasRowLimited,
                    sqlFromValues.numberOfRowLimited,
                    sqlFromValues.hasTopN,
                    sqlFromValues.numberOfTopN,
                    );
        }
    }

    updateDataSourceAfterReplacement(): void {
      this.dialogService.open(ReplaceDataSourceConfirmUpdateComponent,
        { context:
          {
            warnings: [],
            title:`به روز رسانی منبع داده `,
            message: `در صورت تایید، جدول اکنون به‌روزرسانی می‌شود.`,
          },
        })
        .onClose
        .pipe(take(1))
        .subscribe(
          closeUpdateInputRes => {
            if (closeUpdateInputRes === 'confirmUpdate'){
              this.dataSourceFacade
                .checkUpdateDataSourceDataSqlReplace(this.workspaceId, this.dataSourceId);
            } else if (closeUpdateInputRes === 'declineUpdate'){
              window.location.reload();
            }
          },
        );
    }

    checkValidator($event): void {
        this.validForm = $event != null;
        this.formValues = $event;
    }

    formValueChanges($event): void {
      this.formValueChangesData = $event;
    }

    onConnectionTypeChange(connectionType: ConnectionType){
      this.selectedConnectionType = connectionType;
      if(this.connection.connectionType === 'Selectable' && this.type === 'EditSqlServer' && connectionType === 'Selectable'){
        this.init();
      }
    }

    loadConnectionTables(connection: Partial<Connection>) {
        if (connection != null) {
            this.dataSourcePreviewFacade.loadDataBaseConnectionTables(this.workspaceId, connection.id);
        } else {
            this.dataSourcePreviewFacade.resetConnectionTables();
        }
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
